export default __webpack_public_path__ + "static/media/favicon.fb7b483a.svg";